import LTR from "@brand-icons/ploom/package-return/package-return-ltr.svg";
import RTL from "@brand-icons/ploom/package-return/package-return-rtl.svg";

import { iconFactory } from "../iconFactory";

export const PackageReturnIcon = iconFactory("PackageReturnIcon", LTR, RTL);
